import { Route, Routes, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useContext, useEffect, useState } from 'react';

// Third-party libraries
import 'swiper/css';
import 'swiper/css/bundle';
import 'iconify-icon';

// Styles
import './assets/css/style.css';

import 'react-photo-view/dist/react-photo-view.css';

// General Components
import Navbar from './component/Navbar';
import Footer from './component/Footer';
import Gallery from './component/Gallery';
import NewLetter from './component/NewLetter';
import ScrollBotton from './component/ScrollBotton';
import ProtectedRoute from './component/ProtectedRoute.jsx';

// Dashboard Components
import TopNav from './component/dashboard/generalComponent/TopNav.jsx';
import MainNav from './component/dashboard/generalComponent/MainNav.jsx';
import Dashboar_Footer from './component/dashboard/generalComponent/Dashboar_Footer.jsx';

// Screens - Public
import LandingPage from './screens/LandingPage';
import AboutUs from './screens/about_us';
import ContactUs from './screens/ContactUs.jsx';
import Portfolio from './screens/Portfolio';
import Blog from './screens/Blog.jsx';
import BlogDetails from './screens/BlogDetails.jsx';
import Shop from './screens/RefactoredShop.jsx';
import CleanedShop from './screens/CleanedShop.jsx';
import Cart from './screens/Cart.jsx';
import Policy from './screens/Policy.jsx';
import Wishlist from './screens/Wishlist.jsx';
import CategoryPage from './screens/CatgeoryPage.jsx';
import BrandPage from './screens/BrandPage.jsx';

// Screens - Authentication
import Signin from './screens/auth/Signin.jsx';
import ForgotPassword from './screens/auth/ForgotPassword.jsx';
import AdminLogin from './screens/auth/admin_login.jsx';

// Screens - Dashboard
import Home from './screens/dashboard/Home.jsx';
import Product from './screens/dashboard/product/Product.jsx';
import DeviceProduct from './screens/dashboard/product/DeviceProduct.jsx';
import Orders from './screens/dashboard/orders/Orders.jsx';
import OrdersDetails from './screens/dashboard/orders/OrdersDetails.jsx';
import Chat from './screens/dashboard/Chat.jsx';
import Admin_List from './screens/dashboard/admin/Admin_List.jsx';
import Create_Admin from './screens/dashboard/admin/Create_Admin.jsx';
import Customers_List from './screens/dashboard/customers/Customers_List.jsx';
import View_Customer from './screens/dashboard/customers/View_Customer.jsx';

// Redux Services
import { getProfile } from './redux/admin/profile/profile_service_syn.js';
import Edit_Admin from './screens/dashboard/admin/Edit_Admin.jsx';
import Edit_Category from './screens/dashboard/category/Edit_Category.jsx';
import EditProduct from './screens/dashboard/product/EditProduct.jsx';
import Category from './screens/dashboard/category/Category.jsx';
import Create_Category from './screens/dashboard/category/Create_Category.jsx';
import Create_Product from './screens/dashboard/product/CreateProduct.jsx';
import Signup from './screens/auth/Signup.jsx';
import User_Home from './screens/user_dashboard/Home.jsx';
import User_Orders from './screens/user_dashboard/orders/Orders.jsx';
import User_OrdersDetails from './screens/user_dashboard/orders/OrdersDetails.jsx';
import User_Chat from './screens/user_dashboard/Chat.jsx';
import User_OrderCart from './screens/user_dashboard/OrderCart.jsx';
import User_Product from './screens/user_dashboard/product/Product.jsx';
import User_DeviceProduct from './screens/user_dashboard/product/DeviceProduct.jsx';
import User_ProtectedRoute from './component/User_ProtectedRoutes.jsx';
import User_TopNav from './component/dashboard/user_generalComponent/User_TopNav.jsx';
import User_MainNav from './component/dashboard/user_generalComponent/User_MainNav.jsx';
import { UserGetProfile } from './redux/user/user_profile/user_profile_service_syn.js';
import NormalChat from './screens/dashboard/NormalChat.jsx';
import UserNormalChat from './screens/user_dashboard/NormalChat.jsx';
import { AppContext } from './context/context.js';
import Blogs from './screens/dashboard/blog/Blogs.jsx';
import Create_Blogs from './screens/dashboard/blog/CreateBlog.jsx';

import 'ckeditor5/ckeditor5.css';
import 'ckeditor5-premium-features/ckeditor5-premium-features.css';
import BlogAdminDetails from './screens/dashboard/blog/BlogDetails.jsx';
import Edit_Blogs from './screens/dashboard/blog/EditBlogs.jsx';
import UserWishList from './screens/user_dashboard/UserWishList.jsx';
import ProductDetails from './screens/ProductDetails.jsx';
import Notification from './component/dashboard/user_generalComponent/Notification.jsx';
import Profile from './screens/user_dashboard/Profile.jsx';
import Brand from './screens/dashboard/brand/brand.jsx';
import Create_Brand from './screens/dashboard/brand/create_brand.jsx';
import Edit_Brand from './screens/dashboard/brand/edit_brand.jsx';
import Macue from './screens/dashboard/macue/macue.jsx';
import Create_Macue from './screens/dashboard/macue/create_macue.jsx';
import Edit_Macue from './screens/dashboard/macue/edit_macue.jsx';
import Review from './screens/dashboard/review/review.jsx';
import Create_Review from './screens/dashboard/review/create_review.jsx';
import Edit_Review from './screens/dashboard/review/edit_review.jsx';
import Create_Major_Category from './screens/dashboard/major_category/Create_Category.jsx';
import MajorCategory from './screens/dashboard/major_category/Category.jsx';
import ScrollToTop from './component/ScrollToTop.jsx';
import Reels from './screens/dashboard/reels/reels.jsx';
import Create_Reels from './screens/dashboard/reels/create_reels.jsx';
import Edit_Reels from './screens/dashboard/reels/edit_reels.jsx';

// import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  const { socket } = useContext(AppContext);

  const dispatch = useDispatch();
  const location = useLocation();
  const admintoken =
    !localStorage.getItem('admin_token') ||
    localStorage.getItem('admin_token') === 'undefined'
      ? false
      : true;

  const token =
    !localStorage.getItem('token') ||
    localStorage.getItem('token') === 'undefined'
      ? false
      : true;

  const isDashboard = location.pathname.includes('admin_dashboard');
  const userDashboard = location.pathname.includes('user_dashboard');

  useEffect(() => {
    if (isDashboard) {
      dispatch(getProfile());
    }

    if (userDashboard) {
      dispatch(UserGetProfile());
    }
  }, [dispatch, isDashboard, userDashboard]);

  useEffect(() => {
    socket.emit('connected');
  }, []);

  socket.off('connected-user').on('connected-user', (room) => {
    console.log(room, 'visions');
  });
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="matchbody">
      <div
        className={
          isDashboard || userDashboard ? 'wrapper' : 'main__content_wrapper'
        }
      >
        {!isDashboard && !userDashboard && <Navbar />}
        {isDashboard && (
          <TopNav toggleSidebar={toggleSidebar} isOpen={sidebarOpen} />
        )}
        {isDashboard && (
          <MainNav toggleSidebar={toggleSidebar} isOpen={sidebarOpen} />
        )}

        {userDashboard && (
          <User_TopNav toggleSidebar={toggleSidebar} isOpen={sidebarOpen} />
        )}
        {userDashboard && (
          <User_MainNav toggleSidebar={toggleSidebar} isOpen={sidebarOpen} />
        )}

        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/about_us" element={<AboutUs />} />
          <Route path="/contact_us" element={<ContactUs />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog-details/:id" element={<BlogDetails />} />
          <Route path="/shoplist" element={<Shop />} />
          <Route path="/shop" element={<CleanedShop />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/wishlist" element={<Wishlist />} />
          <Route path="/policy" element={<Policy />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/notification" element={<Notification />} />
          <Route path="/categories/:categoryName" element={<CategoryPage />} />
          <Route path="/brand/:brandName" element={<BrandPage />} />
          <Route path="/product/:id" element={<ProductDetails />} />

          {/* Authentication Routes */}
          <Route path="/auth/signin" element={<Signin />} />
          <Route path="/auth/signup" element={<Signup />} />
          <Route path="/auth/admin_login" element={<AdminLogin />} />
          <Route path="/auth/reset_password" element={<ForgotPassword />} />

          {/* Protected Dashboard Routes */}
          <Route
            path="/admin_dashboard/*"
            element={
              <ProtectedRoute isAuthenticated={admintoken}>
                <Routes>
                  <Route path="home" element={<Home />} />
                  <Route path="category" element={<Category />} />
                  <Route path="create_category" element={<Create_Category />} />
                  <Route path="edit_category" element={<Edit_Category />} />

                  <Route path="major_category" element={<MajorCategory />} />
                  <Route
                    path="create_major_category"
                    element={<Create_Major_Category />}
                  />

                  <Route path="product" element={<Product />} />
                  <Route
                    path="view_product/:productId"
                    element={<DeviceProduct />}
                  />

                  <Route path="create_product" element={<Create_Product />} />
                  <Route path="edit_product" element={<EditProduct />} />
                  <Route path="orders" element={<Orders />} />
                  <Route
                    path="view_order/:viewId"
                    element={<OrdersDetails />}
                  />
                  <Route path="chat" element={<Chat />} />
                  <Route path="support_chat" element={<NormalChat />} />
                  <Route path="admins" element={<Admin_List />} />
                  <Route path="create_admins" element={<Create_Admin />} />
                  <Route path="edit_admins" element={<Edit_Admin />} />
                  <Route path="customers" element={<Customers_List />} />
                  <Route
                    path="view_customer/:userId"
                    element={<View_Customer />}
                  />

                  <Route path="blogs" element={<Blogs />} />
                  <Route path="create_blog" element={<Create_Blogs />} />
                  <Route
                    path="view_blog/:blogId"
                    element={<BlogAdminDetails />}
                  />
                  <Route path="edit_blog" element={<Edit_Blogs />} />

                  <Route path="brand" element={<Brand />} />
                  <Route path="create_brand" element={<Create_Brand />} />
                  <Route path="edit_brand" element={<Edit_Brand />} />

                  <Route path="macue" element={<Macue />} />
                  <Route path="create_macue" element={<Create_Macue />} />
                  <Route path="edit_macue" element={<Edit_Macue />} />

                  <Route path="review" element={<Review />} />
                  <Route path="create_review" element={<Create_Review />} />
                  <Route path="edit_review" element={<Edit_Review />} />

                  <Route path="reels" element={<Reels />} />
                  <Route path="create_reels" element={<Create_Reels />} />
                  <Route path="edit_reels" element={<Edit_Reels />} />
                </Routes>
              </ProtectedRoute>
            }
          />

          {/* Protected Users Dashboard Routes */}
          <Route
            path="/user_dashboard/*"
            element={
              <User_ProtectedRoute isAuthenticated={token}>
                {/* <Layout> */}
                <Routes>
                  <Route path="home" element={<User_Home />} />
                  <Route path="product" element={<User_Product />} />
                  <Route
                    path="view_product/:productId"
                    element={<User_DeviceProduct />}
                  />
                  <Route path="orders" element={<User_Orders />} />
                  <Route
                    path="view_order/:viewId"
                    element={<User_OrdersDetails />}
                  />
                  <Route path="cart" element={<User_OrderCart />} />

                  <Route path="wish_list" element={<UserWishList />} />

                  <Route path="chat" element={<User_Chat />} />
                  <Route path="support_chat" element={<UserNormalChat />} />
                  <Route path="user_profile" element={<Profile />} />
                </Routes>
                {/* </Layout> */}
              </User_ProtectedRoute>
            }
          />
        </Routes>

        {!isDashboard && !userDashboard && <Footer />}
        {!isDashboard && !userDashboard && <Gallery />}
        {!isDashboard && !userDashboard && <NewLetter />}
        {!isDashboard && !userDashboard && <ScrollBotton />}
        {(isDashboard || userDashboard) && <Dashboar_Footer />}
        {!isDashboard && !userDashboard && <ScrollToTop />}
      </div>
    </div>
  );
}

export default App;
